import { withScope, captureException, captureMessage } from '@sentry/gatsby';

export const reportToSentry = ({ error, level = 'fatal', extra }) => {
  withScope(scope => {
    const captureEvent = typeof error === 'string' ? captureMessage : captureException;

    scope.setLevel(level);
    if (extra) scope.setExtras(extra);

    captureEvent(error, scope);
  });
};
